/*
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-default';

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = 'ja';
export const currentUser = {};
export const ROLE_MASTER = 'ORGANIZATION';

export const themeColorStorageKey = '__theme_selected_color';
export const isMultiColorActive = true;
export const defaultColor = 'light.purplemonster';
export const isDarkSwitchActive = true;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';
export const isAuthGuardActive = true;
export const colors = [
  'bluenavy',
  'blueyale',
  'blueolympic',
  'greenmoss',
  'greenlime',
  'purplemonster',
  'orangecarrot',
  'redruby',
  'yellowgranola',
  'greysteel',
];

export const typeMessageSuccess = 'success';
export const typeMessageError = 'error';

export const messageValidation = {
  email: {
    required: 'メールアドレスをご入力ください',
    invalid: '正しいメールアドレスを入力してください',
  },
  password: {
    required: 'パスワードをご入力ください',
    min: 'パスワードは最低でも6文字必要です',
    max: 'パスワードは最大20文字になります',
    invalid: 'パスワードにスペースは使用できません。',
  },
  first_name: {
    required: '姓をご入力ください',
  },
  last_name: {
    required: '名をご入力ください',
  },
  sex: {
    required: '必須項目をご入力ください',
  },
  dob: {
    required: '生年月日をご入力ください'
  },
}
